// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22qvq","col":"styles_col__3b-Rf"};